import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsMultiNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M8.99 7.382L7.637 9.75h-.595V11h1.32l.648-1.132 1.98 3.34L12.35 11H13V9.75h-1.35l-.64 1.041z" />
        <path d="M11.124 2.876a6 6 0 10-8.247 8.248 6.031 6.031 0 002 2 6 6 0 108.248-8.247 6.031 6.031 0 00-2.001-2zM6 1.25c.964 0 1.86.287 2.61.78a6 6 0 00-6.58 6.58A4.75 4.75 0 016 1.25zM4 10c0 .206.01.41.03.61a4.75 4.75 0 016.58-6.58A6 6 0 004 10zm6-4.75a4.75 4.75 0 110 9.5 4.75 4.75 0 010-9.5z" />
      </g>
    </svg>
  )
);
SvgSportsMultiNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsMultiNormalXsmall;
